import axios from '../../../../api/axios';

const initialStatus = {
  pending: true,
  sendToFreight: false,
  sendToAdmin: false,
  tendering: true,
  returned: false,
  rejected: false,
  getWaybill: false,
  movingTowardsOrigin: false,
  transporting: false,
  delivered: false,
  canceled: false,
}
const queryInitialStatus = {
  pending: false,
  sendToFreight: false,
  sendToAdmin: false,
  tendering: false,
  returned: false,
  rejected: false,
  getWaybill: false,
  movingTowardsOrigin: false,
  transporting: false,
  delivered: false,
  canceled: false,
}

export const initialState = {
  loading: true,
  orders: null,
  page: null,
  filters: {
    status: initialStatus,
    fleetOptions: [],
    destinationState: null,
  },
};
export const reducer = (state, action) => {
  const { payload, type } = action;
  switch (type) {
    case 'LOADING':
      return { ...state, loading: true };
    case 'LOADED':
      return { ...state, loading: false };
    case 'ORDERS':
      return { ...state, orders: payload, loading: false };
    case 'PAGE':
      return { ...state, page: payload, loading: true };
    case 'ORDER_STATUS':
      return {
        ...state,
        filters: {
          ...state.filters,
          status: { ...state.filters.status, [payload.name]: payload.checked },
        },
      };
    case 'QUERY_ORDER_STATUS':
      return {...state,filters:{...state.filters,status:{
        ...queryInitialStatus,[payload]:true
      }}}
    case 'FLEET_OPTIONS':
      return { ...state, filters: { ...state.filters, fleetOptions: payload } };
    case 'DESTINATION':
      return {
        ...state,
        filters: { ...state.filters, destinationState: payload },
      };
    default:
      return { ...state };
  }
};
export const actions = {
  fetchingOrders: async (page, limit, filters) => {
    try {
      const { data: orders } = await axios.post(`/api/v1/admin/orders/list`, {
        page,
        limit,
        filters
      });
      return orders;
    } catch (error) {
      return new Error(error);
    }
  },
};
